module.exports = __webpack_public_path__ + "img/htc-logo.2265d5bb.png";